export const LOGIN_TOKEN = 'user/token'
